import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavComponent } from './core/nav/nav.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [NavComponent, RouterOutlet],
})
export class AppComponent {
  title = 'EasyLoc';
}
